import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Box, Button } from '@mui/material';

const InvalidTokenScreen = ({ errorMessage }) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: '24px',
        textAlign: 'center',
        backgroundColor: '#f8f9fa',
      }}
    >
      <Typography
        variant="h4"
        color="error"
        gutterBottom
        sx={{
          display: 'block',
          maxWidth: '100%',
        }}
      >
        {errorMessage ? errorMessage : 'Invalid Token'}
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        Please check your link or contact support at <a href="mailto:CIRA@CloudOMax.com" style={{ color: '#337ab7' }}>CIRA@CloudOMax.com</a>.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate('/')}
      >
        Go Home
      </Button>
    </Box>
  );
};

export default InvalidTokenScreen;
